// @ts-nocheck
import './LoaderData.css'
import busbus from '../assets/loadBus3.gif'

const LoaderData = () => {
  return (
    <>
        <div className="loader-body">
            {/* <div className="loader-container bg-info">
                <div className="loader"> */}
                    {/* <div className="gira"></div>
                    <div className="gira-2"></div>
                    <div className="gira-3"></div> */}
                    <div className="img-container">
                        <img className='logo-img' src={busbus} alt="logo" />
                        <span className='lead text-white' style={{top: '50%', left: '50%', transform: 'translate(0%, 215%)'}}><b>Ariztia - El Paico</b></span>
                    </div>
                    {/* <div className="gira-5"></div> */}
                    {/* <div className="gira-4"></div> */}
                    <div className="gira-6"></div>
                    <div className="gira-7"></div>
                    <div className="gira-8"></div>
                    <div className="gira-9"></div>
                {/* </div>
            </div> */}
        </div>
    </>
  )
}

export default LoaderData